import React from 'react';
import { InfoModal } from '../InfoModal/InfoModal';
import InformationCard from '../informationCard/InformationCard';

interface IConfirmationNewAccountModalTypes {
  onOkClick: () => void;
  isOpen?: boolean;
}

export const ConfirmationNewAccountModal = ({
  onOkClick,
  isOpen = true,
}: IConfirmationNewAccountModalTypes): React.JSX.Element => {
  return (
    <InfoModal
      isOpen={isOpen}
      onOkClick={onOkClick}
      onClose={onOkClick}
      width={300}
      title="Subscription Activated"
      info1="Congratulations! You’ve activated your Every Mother subscription."
      buttonLabel="Continue to onboarding"
      footer={<InformationCard text="To manage your subscription, please visit the UHC Store." />}
    />
  );
};
